import axios from 'axios';

export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  if (axios.isAxiosError(error)) {
    const message = error.response?.data?.error?.message;
    if (typeof message === 'string' && message.trim()) {
      return message;
    }
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }

  return fallback;
};

export const getApiErrorCode = (error: unknown): string | undefined => {
  if (!axios.isAxiosError(error)) return undefined;
  const code = error.response?.data?.error?.code;
  return typeof code === 'string' ? code : undefined;
};

export const normalizeAdminLogin = (value: string): string => value.trim().toLowerCase();

export const normalizeAdminEmail = (value: string): string => value.trim().toLowerCase();
